import React, { Fragment } from 'react'
import { Link as LinkTo } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  Accordion,
  AccordionSummary,
  Typography,
  Link,
  Divider,
  AccordionActions,
  ListItemAvatar,
  Avatar,
  IconButton,
} from '@material-ui/core'
import useStyles from './styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import LinkIcon from '@material-ui/icons/Link'
import DeleteIcon from '@material-ui/icons/Delete'
import InfoIcon from '@material-ui/icons/Info'
import FileCopyIcon from '@material-ui/icons/FileCopy'

import { AlertMessage } from './../../Alert/Alert'
import { setAlert } from './../../../store/actions/alert/setAlert'
import { deleteLink } from '../../../store/actions/links/links'

export const LinksList = () => {
  const classes = useStyles()
  const links = useSelector((state) => state.links.links)
  const dispatch = useDispatch()

  const copyToClipboard = (data) => {
    navigator.clipboard.writeText(data)
    dispatch(setAlert(true, 'success', `Link ${data} copied`, 2000))
  }
  const deleteLinkHandler = (id) => {
    dispatch(deleteLink(id))
  }
  if (!links.length) {
    return <AlertMessage text='You have no links yet' />
  }
  return (
    <Fragment>
      {links.map((link) => (
        <div className={classes.root} key={link._id}>
          <Accordion elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1c-content'
              id='panel1c-header'
              className={classes.accordionSummary}
            >
              <div className={classes.column}>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    <LinkIcon />
                  </Avatar>
                </ListItemAvatar>
              </div>
              <div>
                <Typography className={classes.link}>
                  {
                    <Link
                      href={link.generatedLink}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {`${link.generatedLink}`}
                    </Link>
                  }
                </Typography>
              </div>
            </AccordionSummary>

            <Divider />
            <AccordionActions className={classes.accordionActions}>
              <div>
                <Typography className={`${classes.link} ${classes.originLink}`}>
                  Origin link:&nbsp;
                  <Link
                    href={link.originLink}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {`${link.originLink}`}
                  </Link>
                </Typography>
              </div>
              <div>
                <IconButton
                  color='secondary'
                  aria-label='info'
                  component={LinkTo}
                  to={`/detail/${link._id}`}
                >
                  <InfoIcon />
                </IconButton>
                <IconButton
                  color='primary'
                  aria-label='copy'
                  onClick={() => copyToClipboard(link.generatedLink)}
                >
                  <FileCopyIcon />
                </IconButton>
                <IconButton
                  className={classes.delete}
                  aria-label='delete'
                  onClick={() => deleteLinkHandler(link._id)}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </AccordionActions>
          </Accordion>
        </div>
      ))}
    </Fragment>
  )
}
